import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import { StyledButton } from "components/Button/StyledButton"
import { MarkdownEditor } from "components/MarkdownComponent/MarkdownEditor"
import { TextBlockDiffPreview } from "components/ReportNodeTextBlock/TextBlockDiffPreview"
import { TextBlockInfoCompact } from "components/ReportNodeTextBlock/TextBlockInfoCompact"
import { DataNode } from "graphql/types"
import { isNodeText } from "store/typeGuards"

type ReportNodeTextEditDialogProps = {
  open: boolean
  onClose: () => void
  node: DataNode
  setNode: (node: DataNode) => void
  onSave: () => void
}

export const ReportNodeTextEditDialog = (props: ReportNodeTextEditDialogProps) => {
  const { open, onClose, node, setNode, onSave } = props

  const handleClose = () => {
    onClose()
  }

  return (
    <Dialog maxWidth="lg" fullWidth open={open}>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        Textblock bearbeiten
        <TextBlockInfoCompact dataNode={node} />
      </DialogTitle>
      <DialogContent>
        {node && (
          <>
            <MarkdownEditor
              onChangeContent={(content: string) => setNode({ ...node, text: content })}
              content={isNodeText(node) ? node.text : ""}
            ></MarkdownEditor>
            <TextBlockDiffPreview dataNode={node} />
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", gap: 1 }}>
          <StyledButton buttonType="cancel" onClick={handleClose} variant="contained" />
          <StyledButton
            buttonType="save"
            onClick={onSave}
            disabled={node.text === ""}
            variant="contained"
          />
        </Box>
      </DialogActions>
    </Dialog>
  )
}
